import { useEffect } from 'react';

import { ClientApi } from '@yandex-int/messenger.sdk';
import { Widget } from '@yandex-int/messenger.widget';
import { WidgetEvent } from '@yandex-int/messenger.widget/lib/libs/WidgetEvent/WidgetEvent';

export type UseWidgetListenersParams = {
    counter?: (event: WidgetEvent<ClientApi.Counter>) => void;
    userLoaded?: (event: WidgetEvent<ClientApi.UserLoaded>) => void;
    ready?: (event: WidgetEvent) => void;
    unload?: (event: WidgetEvent) => void;
    error?: (event: WidgetEvent<ClientApi.LegacyError>) => void;
    widget: Widget | null;
};
export const useWidgetEventListeners = (params: UseWidgetListenersParams) => {
    const { widget, counter, userLoaded, ready, unload, error } = params;

    useEffect(() => {
        if (widget) {
            if (counter) {
                widget.events.counter.addListener(counter);
            }
            if (userLoaded) {
                widget.events.userLoaded.addListener(userLoaded);
            }
            if (ready) {
                widget.events.ready.addListener(ready);
            }
            if (unload) {
                widget.events.unload.addListener(unload);
            }
            if (error) {
                widget.events.error.addListener(error);
            }
        }
        return () => {
            if (widget) {
                if (counter) {
                    widget.events.counter.removeListener(counter);
                }
                if (userLoaded) {
                    widget.events.userLoaded.removeListener(userLoaded);
                }
                if (ready) {
                    widget.events.ready.removeListener(ready);
                }
                if (unload) {
                    widget.events.unload.removeListener(unload);
                }
                if (error) {
                    widget.events.error.removeListener(error);
                }
            }
        };
    }, [counter, userLoaded, ready, unload, error, widget]);
};

export default useWidgetEventListeners;
